import { IconButton, TablePagination } from "@material-ui/core";
import { FirstPage, KeyboardArrowLeft, KeyboardArrowRight, LastPage } from "@material-ui/icons";
import React from "react";
import { PaginatorProps } from "./PaginatorProps";
import { PaginatorState } from "../../states/PaginatorState";
import "./Paginator.scss";

export class Paginator extends React.Component<any, PaginatorState> {
  private rowsPerPage: number;
  private handleChangePage: any;
  private handleFirstPageButtonClick: any;
  private handleLastPageButtonClick: any;
  private handleNextPageButtonClick: any;
  private handlePrevPageButtonClick: any;

  constructor(props: PaginatorProps) {
    super(props);

    this.state = {
      page: props.page,
      count: props.count,
    };

    this.rowsPerPage = props.rowsPerPage ?? 10;
    this.handleChangePage = props.handleChangePage?.bind(this);
    this.handleFirstPageButtonClick = props.handleFirstPageButtonClick?.bind(this);
    this.handlePrevPageButtonClick = props.handlePrevPageButtonClick?.bind(this);
    this.handleNextPageButtonClick = props.handleNextPageButtonClick?.bind(this);
    this.handleLastPageButtonClick = props.handleLastPageButtonClick?.bind(this);
  }

  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<PaginatorState>, snapshot?: any): void {
    if (this.props.page !== prevProps.page || this.props.count !== prevProps.count) {
      this.setState({ page: this.props.page, count: this.props.count });
    }
  }

  render() {
    return (
      <div className="paginator-container">
        <TablePagination
          rowsPerPageOptions={[]}
          component="div"
          count={this.state.count}
          rowsPerPage={this.rowsPerPage}
          page={this.state.page}
          onChangePage={this.handleChangePage}
          labelDisplayedRows={({ from, to, count }) => `Pag. ${Math.ceil(from / this.rowsPerPage)} di ${Math.ceil(count / this.rowsPerPage)}`}
          ActionsComponent={(props) => (
            <div className="paginator-actions-container">
              <IconButton onClick={this.handleFirstPageButtonClick} disabled={this.state.page === 0} size="small">
                <FirstPage />
              </IconButton>
              <IconButton onClick={this.handlePrevPageButtonClick} disabled={this.state.page === 0} size="small">
                <KeyboardArrowLeft />
              </IconButton>
              <IconButton onClick={this.handleNextPageButtonClick} disabled={this.state.page >= Math.ceil(this.state.count / this.rowsPerPage) - 1} size="small">
                <KeyboardArrowRight />
              </IconButton>
              <IconButton onClick={this.handleLastPageButtonClick} disabled={this.state.page >= Math.ceil(this.state.count / this.rowsPerPage) - 1} size="small">
                <LastPage />
              </IconButton>
            </div>
          )}
        />
      </div>
    );
  }
}
